module.exports = __webpack_public_path__ + "static/testi5-77ac88beb3bca52a38709afd0b12c6a7.jpg";